module.exports = __webpack_public_path__ + "img/logo.5eef5e8f.png";